







































































































































































import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IClient } from "@/models/clients";
import { ClientRoutes } from "@/data/enums/router";
import { IContractProduct } from "@/models/contracts";
import { IsActiveParam } from "@/data/filters/contractProducts";
import { IProduct } from "@/models/products";

@Component({
  components: {
    "cprods-grouping-provider": () =>
      import(
        "@/components/app/global/contractProducts/cProdsGroupingProvider.vue"
      ),
    "cprod-rows-with-funcs": () =>
      import("@/components/app/global/contractProducts/cProdRowsWithFuncs.vue"),
    "cprods-onboarding": () =>
      import("@/components/app/global/contractProducts/cProdsOnboarding.vue")
  }
})
export default class CProdsByGroup extends Vue {
  // Props

  @Prop({ required: true })
  public clientId!: IClient["id"];

  public activeService = "";

  // Computed

  public get viewAllRoute() {
    return { name: ClientRoutes.CONTRACT_PRODUCTS };
  }

  // Methods

  public calcRowStart(cols: number, index: number) {
    return Math.ceil((index + 1) / cols) + 1;
  }

  public toggleService(serviceId) {
    if (this.activeService === serviceId) return (this.activeService = "");
    this.activeService = serviceId;
  }

  public getBindingsForAll() {
    return {
      limit: 5,
      ignoreHistory: true,
      handleLoading: false,
      dataScope: `$client::${this.clientId}`,
      manualFilters: {
        exclude_delegated: 1, // TODO: Remove once API performance is fixed
        ...IsActiveParam()
      }
    };
  }

  public getBindingsForAllIdentified() {
    return {
      limit: 5,
      ignoreHistory: true,
      handleLoading: false,
      dataScope: `$client::${this.clientId}::identified`,
      manualFilters: {
        exclude_delegated: 1, // TODO: Remove once API performance is fixed
        "filter[service_identifier|neq]": "null",
        ...IsActiveParam()
      }
    };
  }

  public getBindingsForIdentifiedGroup(
    identifier: IContractProduct["service_identifier"]
  ) {
    return {
      limit: 5,
      ignoreHistory: true,
      handleLoading: false,
      dataScope: `$identifier::${identifier.replace(/\W/g, "-")}`,
      manualFilters: {
        exclude_delegated: 1, // TODO: Remove once API performance is fixed
        "filter[service_identifier]": identifier,
        ...IsActiveParam()
      }
    };
  }

  public getBindingsForCategoryGroup(categoryId: IProduct["category_id"]) {
    return {
      limit: 5,
      ignoreHistory: true,
      handleLoading: false,
      dataScope: `$category::${categoryId}`,
      manualFilters: {
        exclude_delegated: 1, // TODO: Remove once API performance is fixed
        "filter[product.category.id]": categoryId,
        "filter[service_identifier|eq]": ",null",
        ...IsActiveParam()
      }
    };
  }
}
